// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"78dd8618","157":"44c54f6f","294":"3b1b412f","372":"ddb0ac79","380":"b620122f","425":"71f0b859","685":"5aea46dc","802":"a7cf8ee5","882":"2e15c5f8"}[chunkId] + ".chunk.js";
};